module.exports = __webpack_public_path__ + "img/10_13.80f5ae05.png";